export const getStatusColor = status => {
  if (status === "validated") return "system.green.900";
  if (status === "toComplete") return "system.orange.900";
  return "system.orange.900";
};

export const getBackgroundStatusColor = status => {
  if (status === "validated") return "system.green.100";
  if (status === "toComplete") return "system.orange.100";
  return "system.orange.100";
};